<ng-template ngFor let-notifica [ngForOf]="notifiche" let-indice=index>
<li *ngIf="!notifica.eliminata">
	<p class="link_notifica">
		<a [routerLink]="navigateToUrlNotifica(notifica)" href="" title="data di notifica">
			{{notifica.dataEmissione| dateformatter:'DD/MM/YYYY HH:mm'}}
		</a>
	</p>
	<p>{{notifica.testo}}</p>
	<p class="action" *ngIf="hasOptions">
		<a *ngIf="!notifica.letta" href="javascript:void(0)" (click)="segnalaComeLetta(notifica)" title="Spunta come letta"><span class="glyphicon glyphicon-ok disabilitata" style="color: #505050!important;"></span></a>
		<a *ngIf="notifica.letta" href="javascript:void(0)" (click)="segnalaComeLetta(notifica)" title="Spunta come letta"><span *ngIf="notifica.letta" class="glyphicon glyphicon-ok green"></span></a>
		<a href="javascript:void(0)" (click)="elimina(notifica)" title="Elimina"><span class="glyphicon glyphicon-trash"></span></a>
	</p>

</li>
</ng-template>
